import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/custom-terms/{id}']['GET'];
type Input = ThisApi['params'] & ThisApi['query'];

const getCustomTerms = async ({ id, deviceFingerprint }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(`/custom-terms/${id}`, {
    params: { deviceFingerprint },
  });
  return response.data;
};

export default getCustomTerms;
